import { App } from './App';
import { AuthProvider } from './lib/auth';
import { QuerySeedProvider, type QuerySeed } from './lib/query';
import { ToastProvider } from './lib/toast';

/**
 * Everything inside the router, shared by the browser (main.tsx) and the server's page renderer (entry-server.tsx):
 * a prerendered page hydrates only when both render this same tree with the same seed.
 */
export function AppTree({ seed }: { seed: QuerySeed | null }) {
  return (
    <QuerySeedProvider seed={seed}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </QuerySeedProvider>
  );
}

/** Id of the <script type="application/json"> holding a prerendered page's seed; its #root carries PRERENDERED_ATTR. */
export const SEED_SCRIPT_ID = 'perzo-public-data';
export const PRERENDERED_ATTR = 'data-prerendered';
